import {createSlice} from "@reduxjs/toolkit";
import {setUIMeterFlowVolumeSearchFilter} from "./actions";
import {MeterFlowVolumeSearchCriteria} from "@ots-frontend/ots-data";

type MeterFlowVolumeUIState = {
  searchFilter?: MeterFlowVolumeSearchCriteria
}

const INITIAL_STATE: Readonly<MeterFlowVolumeUIState> = {};

const meterFlowVolumeUISlice = createSlice({
  name: "ots-ui/meter-flow-volume",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setUIMeterFlowVolumeSearchFilter,
      (state, {payload}) => {
        state.searchFilter = payload
      }
    );
  }
});

export const meterFlowVolumeUIReducer = meterFlowVolumeUISlice.reducer;
